import * as form from '../form';

export const substanceDrugPublicSafety = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Description: form.textarea(xitem.Description),
        InvolvementDates: form.daterange(xitem.InvolvementDates),
        EstimatedUse: form.text(xitem.EstimatedUse),
        Comments: form.textarea(xitem.Comments),
        UseWhileEmployedPosition: form.text(xitem.UseWhileEmployedPosition), // PVQOnly
        UseWhileEmployedPositionOther: form.textarea(xitem.UseWhileEmployedPositionOther), // PVQOnly
        DrugType: form.radio(xitem.DrugType), // PVQ Only
        DrugTypeOther: form.textarea(xitem.DrugTypeOther), // PVQOnly
        HowManyTimes: form.text(xitem.HowManyTimes), // PVQOnly
        Reason: form.textarea(xitem.Reason), // PVQOnly
      },
    };
  });
  return {
    UsedDrugs: form.branch(data.UsedDrugs),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
